import { SettingType } from '@/modules/settings/types/setting-type';

import { SettingTypeDTO } from '../types/setting-type-dto';

/**
 * Maps SettingTypeDTO (API response) to SettingType (domain model)
 * Returns null for unknown types to gracefully handle unsupported setting types
 */
export const mapSettingTypeFromDTO = (dto: SettingTypeDTO): SettingType | null => {
  const mapping: Record<SettingTypeDTO, SettingType> = {
    [SettingTypeDTO.USER_PROFILE]: SettingType.ProfileInfo,
    [SettingTypeDTO.USER_PASSWORD]: SettingType.Password,
    [SettingTypeDTO.ORGANIZATION_DEPARTMENTS]: SettingType.Departments,
    [SettingTypeDTO.ORGANIZATION_SENIORITIES]: SettingType.Seniorities,
    [SettingTypeDTO.ORGANIZATION_ROLES]: SettingType.Roles,
    [SettingTypeDTO.ORGANIZATION_GENERAL_SETTINGS]: SettingType.General,
    [SettingTypeDTO.ORGANIZATION_EXTERNAL_RATES]: SettingType.ExternalRates,
    [SettingTypeDTO.ORGANIZATION_TIME_OFF]: SettingType.TimeOff,
    [SettingTypeDTO.ORGANIZATION_PERMISSIONS]: SettingType.Permissions,
    [SettingTypeDTO.ORGANIZATION_INTEGRATION]: SettingType.Integrations,
    [SettingTypeDTO.ORGANIZATION_API]: SettingType.API,
    [SettingTypeDTO.ORGANIZATION_PROJECT_CUSTOM_ATTRIBUTES]: SettingType.CustomAttributes,
    [SettingTypeDTO.ORGANIZATION_TAGS]: SettingType.Tags,
    [SettingTypeDTO.ORGANIZATION_MEMBERS_ACCESS]: SettingType.MembersAccess,
  };

  return mapping[dto] ?? null;
};

type ServerSettingType = Exclude<SettingType, SettingType.Notifications>;

/**
 * Maps SettingType (domain model) to SettingTypeDTO (API request)
 */
export const mapSettingTypeToDTO = (type: ServerSettingType): SettingTypeDTO => {
  const mapping: Record<ServerSettingType, SettingTypeDTO> = {
    [SettingType.ProfileInfo]: SettingTypeDTO.USER_PROFILE,
    [SettingType.Password]: SettingTypeDTO.USER_PASSWORD,
    [SettingType.Departments]: SettingTypeDTO.ORGANIZATION_DEPARTMENTS,
    [SettingType.Seniorities]: SettingTypeDTO.ORGANIZATION_SENIORITIES,
    [SettingType.Roles]: SettingTypeDTO.ORGANIZATION_ROLES,
    [SettingType.General]: SettingTypeDTO.ORGANIZATION_GENERAL_SETTINGS,
    [SettingType.ExternalRates]: SettingTypeDTO.ORGANIZATION_EXTERNAL_RATES,
    [SettingType.TimeOff]: SettingTypeDTO.ORGANIZATION_TIME_OFF,
    [SettingType.Permissions]: SettingTypeDTO.ORGANIZATION_PERMISSIONS,
    [SettingType.Integrations]: SettingTypeDTO.ORGANIZATION_INTEGRATION,
    [SettingType.API]: SettingTypeDTO.ORGANIZATION_API,
    [SettingType.CustomAttributes]: SettingTypeDTO.ORGANIZATION_PROJECT_CUSTOM_ATTRIBUTES,
    [SettingType.Tags]: SettingTypeDTO.ORGANIZATION_TAGS,
    [SettingType.MembersAccess]: SettingTypeDTO.ORGANIZATION_MEMBERS_ACCESS,
  };

  const result = mapping[type];
  if (!result) {
    throw new Error(`Unknown SettingType: ${type}`);
  }
  return result;
};
